import { Component } from '@theme/component';

export class RevealBanner extends Component {
  /** @type {boolean} */
  #animating = false;
  
  /** @type {HTMLVideoElement|null} */
  #video = null;

  connectedCallback() {
    this.#video = this.querySelector('video');

    if (!this.#video) {
      console.error("No video element found");
      return;
    }

    this.createIntersectionObserver();

    // window.addEventListener('scroll', () => {
    //   this.#onScroll();
    // })
  }

  createIntersectionObserver() {
    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;

      if (! entry) {
        return;
      }

      console.log(entry, entry.isIntersecting)

      if (entry.isIntersecting) {
          this.#video?.play();
      } else {
          this.#video?.pause();
      }
    });

    observer.observe(this);
  }

  #onScroll() {
    if (this.#animating) {
      return;
    }

    this.#animating = true;

    requestAnimationFrame(() => {
      const rect = this.#video?.getBoundingClientRect();

      if (!rect) {
        this.#animating = false;
        return;
      }

      const viewportHeight = window.innerHeight;
      const visiblePixels = viewportHeight - rect.top;
      const percentage = (visiblePixels / rect.height) * 100;

      this.style.setProperty('--percentage-revealed', `${Math.max(0, Math.min(100, percentage))}%`);

      this.#animating = false;
    });
  }

  toggleMute() {
    if (!this.#video) { return; }

    this.#video.muted = !this.#video.muted;
    this.querySelector('.reveal-banner__button')?.classList.toggle('reveal-banner__button--muted', this.#video.muted);
  }
}

if (!customElements.get('reveal-banner')) {
  customElements.define('reveal-banner', RevealBanner);
    }
